import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { IncompletePickingService } from './shared/incomplete-picking.service';
import { UtilService } from './shared/util.service';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule
  ],
  providers: [IncompletePickingService, UtilService],
  bootstrap: [AppComponent]
})
export class AppModule { }
